import { formatMinutesFromSecondsInISO, getDate } from '@utils/dates';
import { getImage } from '@utils/imageHelper';

const videoObjectSchema = (course) => {
  const {
    name,
    title,
    createdAt,
    embedUrl,
    thumbnail,
    description,
    viewCount,
    videoUrl,
    lessonDuration,
    permalink: url
  } = course;
  const courseVideoSchema = {
    '@context': 'https://schema.org',
    '@type': 'VideoObject',
    name: name || title,
    url,
    description,
    thumbnailUrl: [thumbnail || getImage('test-start-illustration.png')],
    uploadDate: getDate(createdAt),
    contentUrl: videoUrl,
    embedUrl,
    interactionCount: viewCount
  };
  if (lessonDuration)
    courseVideoSchema.duration = formatMinutesFromSecondsInISO(lessonDuration);
  return courseVideoSchema;
};
export default videoObjectSchema;
